const blogHomepage = {
  displayField: 'title',
  name: 'Blog Homepage',
  description: 'Page builder page',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug of Shop',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'category',
      name: 'Category',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'category' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'heroImg',
      name: 'Hero Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'seo',
      name: 'SEO',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'metaTitle',
      name: 'Meta Title',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'metaDescription',
      name: 'Description',
      type: 'Text',
      localized: true,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'openGraphImage',
      name: 'Open Graph Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      linkType: 'Asset'
    },
    {
      id: 'schema',
      name: 'Schema',
      type: 'Text',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'showStickyCta',
      name: 'Show Sticky CTA',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true
    },
    {
      id: 'featuredArticles',
      name: 'FeaturedArticles',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'blogHomepageFeaturedArticles' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'allArticles',
      name: 'All Articles',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'blogHomepageAllArticles' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'contentBlocks',
      name: 'Dynamic Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'wideTextImage',
              'CareersWideTextAndImage',
              'StackedTextImageForm',
              'WideStackedTextImageBlock',
              'newsletterForm',
              'contactForm'
            ]
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ]
    }
  },
  sys: {
    id: 'blogHomepage',
    version: 22,
    updatedAt: '2023-07-25T16:23:18.901Z'
  }
};
export default blogHomepage;